import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import Styles from "../../assets/css/Pages/AboutUs.module.css";
import { Helmet } from "react-helmet-async";
// Loaders
import Loading from "../Loadings/Loading";
// Global Imports
import { useGlobalState } from "../../Functions/GlobalStates";

const About = () => {
  // States Here
  const [IsLoaded, setIsLoaded] = useState(false); // I CAN use this to show loading before all images loads

  // Global States Here //////////////////////////////////////////////////////...............................
  const {
    CheckPage,
    setCheckPage,
    DontAllow,
    setDontAllow,
    PagesWidthHeight,
    setPagesWidthHeight,
  } = useGlobalState();

  // React Referrences
  const CheckPageStateRef = useRef(false); // Ref for the check Page

  // Show And Hide Navbar DropMenu HomePage
  useEffect(() => {
    const handleCheckResize = () => {
      if (!CheckPageStateRef.current) {
        CheckPageStateRef.current = true;
        setCheckPage(true);
        setDontAllow(true);
      }
      // console.log("oN Mount", CheckPageStateRef.current);
      // console.log("Mounted User Entered");
    };
    handleCheckResize(); // call on mount

    // Add the resize event listener
    window.addEventListener("resize", handleCheckResize);

    // Update global state when the component unmounts , It mean when The user Leaves This Page
    return () => {

      <Helmet>
      {/* Page Title */}
      <title>About Us – Affiliators 🛍️</title>
    
      {/* Meta Description */}
      <meta
        name="description"
        content="Learn more about Affiliators, our mission, and how we help online businesses grow with smart strategies."
      />
    
      {/* Keywords */}
      <meta
        name="keywords"
        content="about affiliators, who we are, online business team, ecommerce experts"
      />
    
      {/* Responsive */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
    
      {/* Open Graph Tags */}
      <meta property="og:title" content="About Us – Affiliators 🛍️" />
      <meta
        property="og:description"
        content="Discover the story behind Affiliators and how we support your e-commerce success."
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content="https://affiliators.netlify.app/#/about"
      />
      {/* <meta
        property="og:image"
        content="/images/about/affiliators-team.png"
      /> */}
    
      {/* Twitter Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="About Us – Affiliators 🛍️" />
      <meta
        name="twitter:description"
        content="Meet the team behind Affiliators and learn about our e-commerce mission."
      />
      {/* <meta
        name="twitter:image"
        content="/images/about/affiliators-team.png"
      /> */}
    
      {/* Indexing and Author Info */}
      <meta name="robots" content="index, follow" />
      {/* <link
        rel="canonical"
        href="https://affiliators.netlify.app/#/about"
      /> */}
      <meta name="author" content="Zeeshan Ahmad Kamran" />
      <meta name="language" content="en" />
      <meta httpEquiv="Content-Language" content="en" />
    </Helmet>
    

      if (CheckPageStateRef.current) {
        CheckPageStateRef.current = false;
        setCheckPage(true);
        setDontAllow(false);
      }
      // console.log("oN unMOUNT", CheckPageStateRef.current);
      // console.log("Unmounted User Leaved");
      window.removeEventListener("resize", handleCheckResize);
    };
  }, []);

  const PagesImages = require.context(
    "../../assets/images/Pages/About/Ai-Images",
    false,
    /\.(png|jpe?g|gif|bmp|webp|svg|avif)$/
  );
  const PageImages = [
    PagesImages("./1.avif"),
    PagesImages("./2.avif"),
    PagesImages("./3.avif"),
    PagesImages("./4.avif"),
    PagesImages("./5.avif"),
    PagesImages("./6.avif"),
    PagesImages("./7.avif"),
  ];

  // Preload Images Before render it will help to descrease flickers on img change
  useEffect(() => {
    const preloadImages = async (imageArray, callback) => {
      try {
        await Promise.all(
          imageArray.map((src) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = src;
              img.onload = resolve;
              img.onerror = reject; // Add error handling
            });
          })
        );
        callback(); // Callback after all images are preloaded
      } catch (error) {
        console.error("Error preloading image:", error);
      }
    };

    preloadImages([PageImages[0]], () => {
      setIsLoaded(true); // Set state when all images are loaded
      // console.log("All Images Are Loaded");
    });
  }, []);
  return IsLoaded ? (
    <div className={Styles.AboutContainer}>
      <section className={Styles.AboutSection1}>
        <h1>About Us</h1>
        <div className={Styles.AboutSection1ImgPara1Container}>
          <img src={PageImages[0]} alt="Welcome To My Website" />
          <p>
            Welcome to Bloggers.com, your go-to source for expert gift guides,
            problem-solving blogs, and product recommendations. We help you make
            informed decisions with carefully researched content.
          </p>
        </div>
        <div className={Styles.AboutSection1HeadingImgPara1Container}>
          <h2>Our Mission</h2>
          <div className={Styles.AboutSection1ImgPara2Container}>
            <img src={PageImages[3]} alt="Welcome To My Website" />
            <p>
              We strive to provide valuable insights, practical solutions, and
              top recommendations to make your life easier and more convenient.
            </p>
          </div>
        </div>
        <div className={Styles.AboutSection1HeadingImgPara2Container}>
          <h2>What We Offer</h2>
          <div className={Styles.AboutSection1ImgPara3Container}>
            <img src={PageImages[6]} alt="Welcome To My Website" />
            <p>
              We provide hand-picked gift guides, practical solutions to
              everyday problems, research-backed product recommendations, and
              useful real-life gadgets to enhance your daily life.
            </p>
          </div>
        </div>
        <div className={Styles.AboutSection1HeadingImgPara3Container}>
          <h2>Why Trust Us?</h2>
          <div className={Styles.AboutSection1ImgPara4Container}>
            <img src={PageImages[2]} alt="Welcome To My Website" />
            <p>
              We conduct in-depth research, test products for reliability, and
              focus on user-friendly content to help you find the best solutions
              effortlessly.
            </p>
          </div>
        </div>

        <h2>Affiliate Disclosure</h2>
        <p>
          Some of the links on our site are affiliate links, meaning we may earn
          a commission at no extra cost to you if you make a purchase through
          them. We only recommend products that we genuinely believe provide
          value to our readers.
        </p>

        <h2>Stay Connected</h2>
        <p>
          Have questions or suggestions? Reach out to us at{" "}
          <NavLink to="/customer-support">Contact us</NavLink>
        </p>
      </section>
    </div>
  ) : (
    <Loading />
  );
};

export default About;
